<sl-fieldset size="small" style="display:block" [label]="label">
    <sl-fieldrow>
        <sl-input [disabled]="disabled || readonly" [value]="street" (slInput)="street = $any($event).detail" placeholder="Street and housenumber" i18n-placeholder width="3/4"></sl-input>
        <sl-input [disabled]="disabled || readonly" [value]="apartment" (slInput)="apartment = $any($event).detail" placeholder="floor/apt." i18n-placeholder width="1/4"></sl-input>
    </sl-fieldrow>
    <sl-fieldrow>
        <sl-input [disabled]="disabled || readonly" [value]="postalCode" (slInput)="postalCode = $any($event).detail" placeholder="Zip" i18n-placeholder width="1/4"></sl-input>
        <sl-input [disabled]="disabled || readonly" [value]="city" (slInput)="city = $any($event).detail" placeholder="City" i18n-placeholder width="1/2"></sl-input>
        <sl-select [disabled]="disabled || readonly" width="1/4" [value]="countryCode" (valueChange)="countryCode = $any($event).detail" width="1/4">
            <sl-menu-item value="FO" i18n>Faroe Islands</sl-menu-item>
            <sl-menu-item value="DK" i18n>Denmark</sl-menu-item>
            <sl-menu-item value="NO" i18n>Norway</sl-menu-item>
        </sl-select>
    </sl-fieldrow>
</sl-fieldset>
